export default {
  restaurantbenefits: {
    subtitle: "FOR RESTAURANTS",

    title1: "Why Restaurants Choose",
    title2: "MAHAL",

    desc:
      "MAHAL helps restaurants manage food sourcing efficiently with trusted suppliers, fair pricing, and reliable deliveries.",

    items: {
      1: {
        icon: "fas fa-seedling",
        title: "Fresh & Quality Ingredients",
        desc: "Source vegetables, fruits, meat, and essentials from verified suppliers you can trust.",
      },
      2: {
        icon: "fas fa-tags",
        title: "Transparent Pricing",
        desc: "Compare supplier prices easily with no hidden costs or surprises.",
      },
      3: {
        icon: "fas fa-clock",
        title: "Save Time & Effort",
        desc: "Manage all daily and bulk procurement from one single platform.",
      },
      4: {
        icon: "fas fa-truck",
        title: "Reliable Daily Delivery",
        desc: "Get ingredients delivered on time to keep your kitchen running smoothly.",
      },
      5: {
        icon: "fas fa-boxes-stacked",
        title: "Bulk & Recurring Orders",
        desc: "Place bulk orders or schedule recurring supplies with ease.",
      },
      6: {
        icon: "fas fa-mobile-screen",
        title: "Easy App Ordering",
        desc: "Order anytime through MAHAL app and track your supplies in real time.",
      },
    },

    cta: "Start Ordering for Your Restaurant",
  },
};